<template>
    <v-card
        class="step-card text-center"
        color="#004282"
        height="100%"
    >

        <v-img
            class="mx-auto mb-3"
            :src="icon"
            alt=""
            title=""
            height="60px"
            width="50px"
            contain
        ></v-img>

        <v-img
            class="step-card__arrow"
            :src="arrow"
            alt=""
            title=""
            height="20px"
            width="30px"
        ></v-img>

        <v-card-text>
            <span class="step-card__title">
                <slot name="text"></slot>
            </span>
        </v-card-text>

    </v-card>
</template>

<script>
    export default {
        name: 'StepCard',
        props: {
            icon: {
                type: String,
                required: true,
            },
            arrow: {
                type: String,
                required: false,
            },
            type: {
                type: String,
                required: true,
            }
        },
    }
</script>

<style>

.step-card {
    padding: 15px 10px 10px 10px;
    border-radius: 10px !important;
}

.step-card__title {
    font-size: 16px;
    color: #FFF;
}

.step-card__arrow {
    position: absolute !important;
    top: 15px;
    right: 15px;
}

@media screen and (max-width: 770px) {
    .step-card__arrow {
        transform: rotate(90deg);
    }

    
}

</style>